import type { CreateProject, LifeSpace } from '../db/models'

/** Dieselben Vorgaben wie „Neues Projekt“ in der Seitenleiste (`ProjectsSection`) — für **Verschieben** (#263, #267). */
export function newProjectInput(name: string, lifeSpace: LifeSpace): CreateProject {
  return { name, description: null, color: 'var(--space-500)', status: 'active', lifeSpace, startDate: null, endDate: null, progress: 0 }
}
